import React from 'react';
import Spinner from 'Components/Spinner';
import styles from './index.module.css';

function CustomButton({ name, border, disabled, onClick, loading }) {
   const spinerSmall = 'spinex';
  return (
<button
  disabled={disabled}
  className={styles.customButtonx}
  style={{
    borderColor: border,
    '--hover-bg': border, // Pass border color as a CSS variable
  }}
  onClick={onClick}
>
      {name}
      {loading && <Spinner spinex={spinerSmall} />}

</button>

  );
}

export default CustomButton;
